import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import Api from '@/services/api';

type FrameResult = {
	code: string;
	score: number;
};

type UpdateOwasFrameResponse = {
	status: string;
	message: string;
	data: FrameResult;
};

type UpdateOwasFrameError = AxiosError<any>;

async function updateFrame(params: any): Promise<UpdateOwasFrameResponse> {
	const url = `/ergonomic-tool/owas/report/${params.report_id}/frame/${params.frame_id}`;
	const { data } = await Api.put(url, params);
	return data;
}

export const useUpdateOwasFrame = () => {
	return useMutation<UpdateOwasFrameResponse, UpdateOwasFrameError, any>((payload) => updateFrame(payload));
};
